import { Tooltip } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { IconNotification } from '../../../../../icons'
import { messages } from '../messages'
import { styles } from '../styles'

type Props = {
  hide: boolean
}

export function NotificationAlert(props: Props) {
  const { hide } = props
  const { $t } = useIntl()

  if (hide) {
    return null
  }

  return (
    <Tooltip text={$t(messages.notificationTooltip)} placement="top">
      <div
        data-testid="budget-notification-tooltip"
        className={styles.iconContainer}
      >
        <IconNotification />
      </div>
    </Tooltip>
  )
}
